import { render, staticRenderFns } from "./ImageWithBadgeBand.vue?vue&type=template&id=85611690&"
import script from "./ImageWithBadgeBand.vue?vue&type=script&lang=ts&"
export * from "./ImageWithBadgeBand.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports